import React from "react"
import { Flex, MaxWidth, Box } from "@sqymagma/elements"
import ModDailyHeader from "./Modules/ModDailyHeader"
import { theme } from "../../utils/themeGet"


export default ({ children, frontmatter, ...props }) => {
    return (
        <Box position="relative">
            <ModDailyHeader {...frontmatter} {...props} completePath={frontmatter.path}/>
            <DottedLine />
            <MaxWidth useContainers>
                <Box mx="auto"  width={1}>
                    <Flex width={1} flexDirection="column" mt="1.5em">
                        <Flex flexWrap="wrap" ml={["l", "48px", 0]}>
                            {children}
                        </Flex>
                    </Flex>
            </Box>
        </MaxWidth>
    </Box>
)
}

export const DottedLine = _ => (
    <Box
    position="absolute"
    top="0"
    bottom="0"
    height="100%"
    left={["4%" ,"4%", "50%"]}
    css={`
        border-left: 4px dotted ${theme("color.ui05")};
        z-index: 1;
    `}
    >
        <Point/>
    </Box>
)

export const Point =  _ => (
<Box 
    position="absolute" 
    width="12px" height="12px" 
    bg="brand05"
    borderRadius="50%"
    left="-8px"
    top="2.5rem"
    zIndex="1"
    css={`{
        content:" ";
        box-shadow: 0 0 0 5px ${theme("color.ui05")}
    }`}
></Box>
)

